import React from 'react';
import { translations } from '../Text/translations';
import disneyActivationEn from '../../assets/disneyplus/DisneyPlus_Activation_visual_en.png';
import disneyActivationTc from '../../assets/disneyplus/DisneyPlus_Activation_visual_tc.png';

const DisneyPlusError = ({ currentLang, nickname, mobilenowid, emailnowid }) => {
  return (
    <>
      <div className="name">
        <h2 className="name">{translations[currentLang].disneyplusSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].disneyplusSubjectGreeting2}</h2>
      </div>

      <div className="message">
        <p>{translations[currentLang].disneyplusErrorP}<br /><br />{translations[currentLang].disneyplusErrorP2}</p>
      </div>

      <div className="preview-img">
        <img src={currentLang === 'en' ? disneyActivationEn : disneyActivationTc} alt="" />
      </div>
    </>
  );
};

export default DisneyPlusError;